var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass:
        "cw-block cw-block-biography cw-block-biography-achievements",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          storeEdit: _vm.storeBlock,
          showEdit: _vm.setShowEdit,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "cw-block-biography-content",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "cw-block-biography-type",
                          class:
                            "cw-block-biography-achievements-type-" +
                            _vm.currentData.type,
                        },
                        [_c("h2", [_vm._v(_vm._s(_vm.typeName))])]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "cw-block-biography-details",
                        },
                        [
                          _c(
                            "h3",
                            [
                              _c("translate", [_vm._v("Titel")]),
                              _vm._v(
                                ": " +
                                  _vm._s(_vm.currentData.title) +
                                  "\n                    "
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("h4", [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.currentData.type !== "membership",
                                    expression:
                                      "currentData.type !== 'membership'",
                                  },
                                ],
                              },
                              [_c("translate", [_vm._v("Datum")]), _vm._v(":")],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.currentData.type === "membership",
                                    expression:
                                      "currentData.type === 'membership'",
                                  },
                                ],
                              },
                              [
                                _c("translate", [_vm._v("Startdatum")]),
                                _vm._v(":"),
                              ],
                              1
                            ),
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.getReadableDate(_vm.currentData.date)
                                ) +
                                "\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "h4",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.hasEndDate,
                                  expression: "hasEndDate",
                                },
                              ],
                            },
                            [
                              _c("translate", [_vm._v("Enddatum")]),
                              _vm._v(
                                ": " +
                                  _vm._s(
                                    _vm.getReadableDate(
                                      _vm.currentData.end_date
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "h4",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.hasParticipation,
                                  expression: "hasParticipation",
                                },
                              ],
                            },
                            [
                              _c("translate", [_vm._v("Beteiligung")]),
                              _vm._v(
                                ": " +
                                  _vm._s(_vm.currentData.role) +
                                  "\n                    "
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "h4",
                              [
                                _c("translate", [_vm._v("Beschreibung")]),
                                _vm._v(":"),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "formatted-content ck-content",
                              domProps: {
                                innerHTML: _vm._s(_vm.currentData.description),
                              },
                            }),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Type")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentData.type,
                                      expression: "currentData.type",
                                    },
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })

                                      _vm.$set(
                                        _vm.currentData,
                                        "type",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "certificate",
                                      },
                                    },
                                    [_c("translate", [_vm._v("Zertifikat")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "accreditation",
                                      },
                                    },
                                    [
                                      _c("translate", [
                                        _vm._v("Akkreditierung"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "award",
                                      },
                                    },
                                    [_c("translate", [_vm._v("Auszeichnung")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "book",
                                      },
                                    },
                                    [_c("translate", [_vm._v("Buch")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "publication",
                                      },
                                    },
                                    [
                                      _c("translate", [
                                        _vm._v("Veröffentlichung"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "membership",
                                      },
                                    },
                                    [
                                      _c("translate", [
                                        _vm._v("Mitgliedschaft"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Titel")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentData.title,
                                    expression: "currentData.title",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.currentData.title,
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }

                                    _vm.$set(
                                      _vm.currentData,
                                      "title",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("label", [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.hasEndDate,
                                    expression: "!hasEndDate",
                                  },
                                ],
                              },
                              [_c("translate", [_vm._v("Datum")])],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.hasEndDate,
                                    expression: "hasEndDate",
                                  },
                                ],
                              },
                              [_c("translate", [_vm._v("Startdatum")])],
                              1
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentData.date,
                                  expression: "currentData.date",
                                },
                              ],
                              attrs: {
                                type: "date",
                              },
                              domProps: {
                                value: _vm.currentData.date,
                              },
                              on: {
                                input: function input($event) {
                                  if ($event.target.composing) {
                                    return
                                  }

                                  _vm.$set(
                                    _vm.currentData,
                                    "date",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.hasEndDate,
                                  expression: "hasEndDate",
                                },
                              ],
                            },
                            [
                              _c("translate", [_vm._v("Enddatum")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentData.end_date,
                                    expression: "currentData.end_date",
                                  },
                                ],
                                attrs: {
                                  type: "date",
                                },
                                domProps: {
                                  value: _vm.currentData.end_date,
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }

                                    _vm.$set(
                                      _vm.currentData,
                                      "end_date",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.hasParticipation,
                                  expression: "hasParticipation",
                                },
                              ],
                            },
                            [
                              _c("translate", [_vm._v("Beteiligung")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentData.role,
                                    expression: "currentData.role",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.currentData.role,
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }

                                    _vm.$set(
                                      _vm.currentData,
                                      "role",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "label-text",
                            },
                            [_c("translate", [_vm._v("Beschreibung")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("studip-wysiwyg", {
                            model: {
                              value: _vm.currentData.description,
                              callback: function callback($$v) {
                                _vm.$set(_vm.currentData, "description", $$v)
                              },
                              expression: "currentData.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c("translate", [_vm._v("Informationen zum Erfolge-Block")]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }